<script lang="ts">

    import Modal from "@/components/Modal.svelte";
    import RelatedSingle from "@/components/Inputs/RelatedSingle.svelte";
    import {Button} from "@/components/ui/button";
    import Input from "@/components/Form/Inputs/Input.svelte";
    import Select from "@/components/Inputs/Select.svelte";
    import FormContainer from "@/components/Form/FormContainer.svelte";
    import FormBlock from "@/components/Form/FormBlock.svelte";
    import CustomerTable from "@/components/customers/CustomerTable.svelte";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import {toast} from "svelte-sonner";
    import {useForm} from "@/lib/precognition.svelte";
    import JobTable from "@/components/jobs/JobTable.svelte";
    import Textarea from "@/components/Inputs/Textarea.svelte";
    import DateTime from '@/components/Inputs/DateTime.svelte';
    import { parseFieldOptions } from '@/lib/fieldUtils';

    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
        show: boolean;
    };

    let {blocks, show = $bindable()}: Props = $props();
    let createFormInner: Record<string, any> = {}
    for (const block of blocks) {
        for (const field of block.fields) {
            createFormInner[field.column_name] = null;
        }
    }
    let createForm = $state(useForm(createFormInner, 'post', route('vehicles.store')));

    let isSelectJobOpen = $state(false);
    let jobLabel: string | null = $state(null);

    function close() {
        show = false;
    }

    function submit(e) {
        $createForm.processing = true;
        e.preventDefault();
        $createForm.post(route('vehicles.store'), {
            onSuccess: () => {
                close();
                $createForm.reset();
                toast.success("Vehicle created successfully!");
            },
            onError: (errors) => {
                for (const message of Object.values(errors)) {
                    toast.error("Error creating vehicle. " + message as string);
                }
            }
        });
    }

</script>
{#if show}
    <Modal title="Add New Vehicle" onClose={close}>
        <FormContainer>
            <form onsubmit={submit}>
                {#each blocks as block}
                    <FormBlock label={block.label}>
                        {#each block.fields as field}
                            {#if field.editable}
                                {#if field.ui_type === 'related'}
                                    <RelatedSingle
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                        bind:isOpen={isSelectJobOpen}
                                        bind:valLabel={jobLabel}
                                    >
                                        <JobTable
                                            view="related"
                                            onRowClick={(row) => {
                                                $createForm.job_id = row?.id ?? null;
                                                jobLabel = row?.title ?? '';
                                                isSelectJobOpen = false;
                                            }}
                                        />
                                    </RelatedSingle>
                                {:else if field.ui_type === 'select'}
                                    <Select
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        options={parseFieldOptions(field)}
                                        error={$createForm.errors[field.column_name]}
                                    />
                                {:else if field.ui_type === 'textarea'}
                                    <Textarea
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                    />
                                {:else if field.ui_type === 'datetime'}
                                    <DateTime
                                        label={field.label}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                    />
                                {:else}
                                    <Input
                                        field={field}
                                        bind:value={$createForm[field.column_name]}
                                        error={$createForm.errors[field.column_name]}
                                        onkeydown={() => {}}
                                    />
                                {/if}
                            {/if}
                        {/each}
                    </FormBlock>
                {/each}

                <div class="mt-5 flex justify-end gap-2">
                    <Button type="button" onclick={close}>Cancel</Button>
                    <Button type="submit" disabled={$createForm.processing}>
                        {#if $createForm.processing}Saving...{:else}Save{/if}
                    </Button>
                </div>
            </form>
        </FormContainer>
    </Modal>
{/if}
